import { Expose } from 'class-transformer';

import type LoyaltyMembership from '../types/LoyaltyMembership';


export default class LoyaltyScheme {
  @Expose() id: number = 0;
  @Expose() label: string = '';
  @Expose() membership: (LoyaltyMembership | null) = null;
  @Expose() multiplerewardsenabled: boolean = false;
  @Expose() name: string = '';
  @Expose() provider: string = '';

  constructor(
    id: number,
    label: string,
    membership: LoyaltyMembership,
    multiplerewardsenabled: boolean,
    name: string,
    provider: string,
  ) {
    this.id = id;
    this.label = label;
    this.membership = membership;
    this.multiplerewardsenabled = multiplerewardsenabled;
    this.name = name;
    this.provider = provider;
  }
}